// extracted by mini-css-extract-plugin
module.exports = {"dots":"medium_dots__FrJjC","slider":"medium_slider__OmT3m","button":"medium_button__ylci0"};